import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "../../../config";

function ViewSubscribers() {
  const [subscribers, setSubscribers] = useState([]);

  const loadSubscribers = async () => {
    const res = await fetch(
      `${BACKEND_URL}/api.php?module=newsletter&action=list`
    );

    const data = await res.json();

    if (data.success) {
      setSubscribers(data.data);
    }
  };

  useEffect(() => {
    loadSubscribers();
  }, []);

  const handleDelete = async (id) => {

  if (!window.confirm("Delete this subscriber?")) return;

  try {

    const res = await fetch(
      `${BACKEND_URL}/api.php?module=newsletter`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      }
    );

    const data = await res.json();

    alert(data.message);

    if (data.success) {
      loadSubscribers();
    }

  } catch (err) {
    console.log(err);
    alert("Delete failed");
  }
};

  return (
    <div className="admin-page">
      <h2>Newsletter Subscribers</h2>
         
    <div className="admin-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {subscribers.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.email}</td>
              <td className="action-btns">
                <button className="admin-btn delete" onClick={() => handleDelete(item.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
}

export default ViewSubscribers;